import TargetedView from "../TargetedView";
import { useCallback, useEffect, useState } from "react";
import { isAuthenticated } from "../../utilities/identityUtils";
import {
  getCustomerTierId,
  getConfig,
  getIsLoyaltyAvailable,
} from "../../utilities/loyaltyUtils";
import LoyaltyProgressIndicator from "../../components/progress-indicator";
import PropTypes from "prop-types";
import { useJoinStatus } from "../../context/join-status";
import noticeError from "../../utilities/notice-error";
import {
  setErrorCode,
  setLoyaltyData,
  setCurrentTierId,
} from "../../state/join-loyalty/reducer";
import { useLocaleProvider } from "../../context/locale-provider";

export default function LoyaltyView({ assetsUrl }) {
  const [loaded, setLoaded] = useState(false);
  const [, dispatch] = useJoinStatus();
  const [isAnonymous, setIsAnonymous] = useState(false);
  const { localisedLinks } = useLocaleProvider();

  const handleLoyaltyUnavailable = useCallback(() => {
    window.location.href = localisedLinks.homepage;
  }, [localisedLinks.homepage]);

  const fetchLoyaltyConfig = useCallback(async () => {
    try {
      const loyaltyConfig = await getConfig();
      dispatch(setLoyaltyData(loyaltyConfig));
    } catch (e) {
      noticeError(e);
      return;
    }
  }, [dispatch]);

  const determineIsLoyaltyCustomer = useCallback(async () => {
    const authenticated = await isAuthenticated();
    if (!authenticated) {
      setIsAnonymous(true);
    } else {
      try {
        const currentTierId = await getCustomerTierId();

        if (currentTierId) {
          dispatch(setCurrentTierId(currentTierId));
        }
      } catch (e) {
        const errorCode = e?.response?.data[0]?.errorCode;
        dispatch(setErrorCode(errorCode ? errorCode : e));
      }
    }
  }, [dispatch]);

  useEffect(() => {
    const initialiseLoyalty = async () => {
      try {
        const isLoyaltyAvailable = await getIsLoyaltyAvailable();

        if (!isLoyaltyAvailable) {
          handleLoyaltyUnavailable();
          return;
        }

        await Promise.all([fetchLoyaltyConfig(), determineIsLoyaltyCustomer()]);

        setLoaded(true);
      } catch (error) {
        noticeError(error);
      }
    };
    initialiseLoyalty();
  }, [
    determineIsLoyaltyCustomer,
    fetchLoyaltyConfig,
    handleLoyaltyUnavailable,
  ]);

  return (
    <>
      {loaded ? (
        <TargetedView assetsUrl={assetsUrl} isAnonymous={isAnonymous} />
      ) : (
        <LoyaltyProgressIndicator />
      )}
    </>
  );
}

LoyaltyView.propTypes = {
  assetsUrl: PropTypes.string,
};
